<template>
  <v-app>
    <div style="width: 100%; zoom: 0.92; margin: 0 auto; padding: 15px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: fit-content"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td style="width:40%; padding-left: 15px;">
            <p style="margin-top: 0;margin-bottom: 0; text-align: left; line-height: 1;"><span style="white-space: pre; font-size: 10pt;">{{ getCompanySetting('CompanySettings', 'CompanyAddress')}}</span></p>
          </td>
          <td>&nbsp;</td>
          <td style="width: 35%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Bill Num</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.billnum }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.billdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Due Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.billduedate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%">
        <tr>
          <td><div style="text-align: center;"><h4 class="ma-0"><b>{{ initvalue.billtype }}</b></h4></div></td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%;">
        <tr>
          <td style="width:45%; padding-left: 15px;">
            <div style=" text-align: start; margin: 0;">
              <span style="font-size: 11pt; font-weight: bold; text-align: start;">Vendor</span>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.billname }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.billaddress }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.billphone }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.billmobile }}</p>
            </div>          
          </td>
          <td>&nbsp;</td>
          <td style="width: 45%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold;">Bill Type</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.billtype }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Ref Num</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.refnum }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_location }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Department</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_department }}</span></td>
              </tr>

            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 7px; padding-bottom: 7px;"></div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="15%">Date</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="20%">Account</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Description</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid"></th>
            <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid" width="15%">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans) in initvalue.transactions"  v-bind:key="trans._id">
            <td style="vertical-align: top;">{{ new Date(trans.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</td>
            <td style="vertical-align: top;">{{ data_account(trans.accountid) }}</td>
            <td style="vertical-align: top;">{{ trans.itemdesc }}</td>
            <td style="vertical-align: top;">&nbsp;</td>
            <td style="vertical-align: top; text-align: right">{{ trans.itemamount.toFixed(2) }}</td>
          </tr>
          <tr><td colspan="5" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
          <tr>
            <td colspan="5" style="vertical-align: text-top; ">
              <table width="100%">
                <tr>
                  <td style="max-width: 200px;"><p style="margin:0"><strong>Note:</strong></p> <span style="white-space: pre">{{ initvalue.billnote }}</span></td>
                  <td width="40%" style="align-content: start;">
                    <table v-if="initvalue.billtotal!=null" width="100%">
                      <tr>
                        <td><span style="font-size: 11pt; font-weight: bold">Total: </span></td>
                        <td v-if="initvalue.primaryCurrency!=initvalue.secondaryCurrency" style="text-align: right"><span style="font-size: 11pt;">{{ convertCurrency(initvalue.billtotal).toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.secondaryCurrency }}</span></td>
                        <td v-else style="text-align: right"><span></span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.billtotal.toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.primaryCurrency }}</span></td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr><td colspan="5">&nbsp;</td></tr>
          <tr v-if="data_paymethod!=null">
            <td v-if="data_paymethod.paymethodtype=='Qr Code'" colspan="5"><p style="margin:0"><strong>Payment Qr Code:</strong></p> <span style="white-space: pre"></span>
              <div>
                <img :src="data_paymethod.qrcodeimage" contain width="175">
              </div>
              <p style="margin:0"><strong>{{ data_paymethod.paymethodinfo }}</strong></p>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../../util/tools';

export default {
  name: 'PrintBill',
  props: {
    id: String
  },
  data() {
    return {
      logo: null,
      initvalue: {},
      data_company: {},
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getBillRequest', 'getCompanyDataRequest']),
    getCompanySetting(code, name){
      if(this.data_company.settings==null || this.data_company.settings.length==0) return '';
      let results = this.data_company.settings.find(setting=>setting.settingcode==code);
      let result = results.settinglists.find(result=>result.settingname==name);
      let value = result!=null ? result.settingvalue : '';
      if(value.trim()=='true') value=true;
      else if(value.trim()=='false') value=false;
      return value;
    },
    data_account(id){
      if(this.data_company.accounts==null || this.data_company.accounts.lenght==0) return null;
      let account = this.data_company.accounts.find(i=>i._id == id);
      if(account!=null) return account['accountname'];
      return '';
    },
    convertCurrency(amount){
      let rate = parseFloat(this.initvalue.currencyRate);
      if(rate==null) rate = 0;
      return amount * rate;
    },
  },
  computed: {
    data_department(){
      if(this.data_company.departments==null || this.data_company.departments.lenght==0) return null;
      let department = this.data_company.departments.find(i=>i._id == this.initvalue.departmentid);
      if(department!=null) return department['departmentname'];
      return '';
    },
    data_location(){
      if(this.data_company.locations==null || this.data_company.locations.lenght==0) return null;
      let location = this.data_company.locations.find(i=>i._id == this.initvalue.locationid);
      if(location!=null) return location['locationcode'];
      return '';
    },
    data_paymethod(){
      if(this.data_company.paymethods==null || this.data_company.paymethods.lenght==0) return null;
      let paymethod = this.data_company.paymethods.find(i=>i._id == this.initvalue.paymethodid);
      if(paymethod!=null) return paymethod;
      return null;
    }
  },
  async created() {
    if(this.id){
      this.initvalue = await this.getBillRequest(this.id);
      //if(this.initvalue==null) this.$router.push({ path: '/error' });
      this.logo = getLogo(this.initvalue.companyid);
      this.data_company = await this.getCompanyDataRequest(this.initvalue.companyid);
      console.log(this.data_company)
    }
  },
}

</script>

<style src="./../Print.scss" lang="scss"/>
